import { ContainerTheme } from 'app/components/container/container-theme';

export const largeContainerStyles: ContainerTheme = {
    maxWidth: '1200px',
};
